export const PRESENCE_STATES = {
  BUSY: 'busy',
  AWAY: 'away',
  OFFLINE: 'offline',
  ACTIVE: 'active',
};

export const PRESENCE_STATES_LIST = [
  PRESENCE_STATES.BUSY,
  PRESENCE_STATES.AWAY,
  PRESENCE_STATES.OFFLINE,
  PRESENCE_STATES.ACTIVE,
];
